module.exports = __webpack_public_path__ + "static/media/tv-icon.0278e17a.svg";